import { normalizedBig } from '@cex/shared-modules';
import Big from 'big.js';
import { WITHDRAWAL_LIMITS } from '../utils/constants';
import { isValidNumber } from './formatters';
import { getLocale } from '@/shared/helpers/i18n';

export const getCryptoAmount = (value: string | number, assetId?: string, includeSymbol = true) => {
  if (isNaN(Number(value))) {
    return '';
  }
  const amount = new Intl.NumberFormat(getLocale(), {
    maximumSignificantDigits: 18
  }).format(Number(value));

  return assetId && includeSymbol ? `${amount}\xa0${assetId.toUpperCase()}` : amount;
};

export const getCryptoWithdrawalPayload = (values, asset, uuid) => {
  const { amount, targetAddress, destinationTag } = values;

  // BasicUnitAmount is a check if it is a decimal and converts it if its not
  // This is because of the API requirements to now receive instead of
  // an integer in a fractional_unit to decimals in main_unit BTF-639
  // https://github.com/MikeMcl/big.js/issues/53

  const basicUnitAmount =
    // @ts-ignore
    normalizedBig(amount).toFixed() % 1 === 0 ? normalizedBig(amount).toFixed(1) : normalizedBig(amount).toFixed();

  const tag = destinationTag === undefined ? null : destinationTag;

  return {
    amount: basicUnitAmount,
    assetId: asset.id,
    destinationTag: tag,
    targetAddress,
    uuid
  };
};

const isNumeric = (value) => {
  return /^-?\d+$/.test(value);
};

export const isValidDestinationTag = (value: string): boolean => {
  if (!value || !isNumeric(value)) {
    return false;
  }

  if (Number.parseInt(value) < 0 || Number.parseInt(value) > 4294967295) {
    return false;
  }

  return true;
};

export const validateCrypto = (value: string, assetId: string, availableAssetQuantity: Big): string | null => {
  const bigQuantityCrypto = normalizedBig(value);

  if (!isValidNumber(value)) {
    return 'error.input_is_not_number';
  }

  if (bigQuantityCrypto.lte(0) || bigQuantityCrypto.lt(WITHDRAWAL_LIMITS[assetId])) {
    return 'error.input_too_small';
  }

  if (availableAssetQuantity.lt(bigQuantityCrypto)) {
    return 'error.insufficient_funds';
  }

  if (
    availableAssetQuantity.gt(0) &&
    bigQuantityCrypto.gte(WITHDRAWAL_LIMITS[assetId]) &&
    bigQuantityCrypto.lte(availableAssetQuantity)
  ) {
    return null;
  }
  return null;
};

export const cryptoAmountValidation = (input) => {
  return input.includes(',') || input.includes('.');
};
